<div *ngIf="showFooter" class="page-layout">
    <div class="container" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="copyright" fxFlex="50" [innerHTML]="copyrightText"></div>

        <div class="logo" fxFlex="50">
            <img [src]="footerConfig.logo" />
        </div>
    </div>
</div>
